import React, { useRef, useEffect, useState } from 'react'
import { View, StyleSheet, Animated, LayoutChangeEvent } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'

type ProgressBarProps = {
  step: number
  totalSteps: number
}

export const ProgressBar = ({ step, totalSteps }: ProgressBarProps) => {
  const theme = useTheme()
  const styles = getStyle(theme)

  const [containerWidth, setContainerWidth] = useState(0)
  const animatedWidth = useRef(new Animated.Value(0)).current

  useEffect(() => {
    const newValue = (Math.min(step, totalSteps) / totalSteps) * containerWidth
    let progressAnimation: Animated.CompositeAnimation | null = null

    progressAnimation = Animated.timing(animatedWidth, {
      toValue: newValue,
      duration: 300,
      useNativeDriver: false,
    })
    progressAnimation.start()

    // Cleanup function pour arrêter l'animation si le composant se démonte
    return () => {
      progressAnimation?.stop()
    }
  }, [step, totalSteps, containerWidth, animatedWidth])

  // Cleanup général au démontage du composant
  useEffect(() => {
    return () => {
      // Arrêter toutes les animations en cours
      animatedWidth.stopAnimation()
    }
  }, [animatedWidth])

  const handleLayout = (event: LayoutChangeEvent) => {
    const newWidth = event.nativeEvent.layout.width
    setContainerWidth(newWidth)
  }

  return (
    <View style={styles.container} onLayout={handleLayout}>
      <Animated.View style={[styles.progressBar, { width: animatedWidth }]} />
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      height: 4,
      width: '70%',
      backgroundColor: theme.colors.grey,
      borderRadius: theme.border.medium,
    },
    progressBar: {
      height: '100%',
      backgroundColor: theme.colors.primary,
      borderRadius: theme.border.medium,
    },
  })
